import {get,post} from '../utils/request'
import qs from 'qs'

// report
// 家长/学生 下载/查看 学生报告 pdf   
//year年份  category用户类型,student/teacher/parents  user_id用户id
export const downLoad = (params)=>get('https://yingde_api.ydassess.com/health/report/download',params)


// 有mock数据
// 针对班级优先关注点（学校ID,，年级ID，班级ID)
// grade年级  year年份  code全国、省、地市、区县、学校、班级的 id/code
export const focusRecommend = (params)=>get('https://yingde_api.ydassess.com/health/school/class/focus/recommend/resources',params)


// 本区各学校 某年级 六大领域/四大领域 得分柱状图（与“优、良、中、待提高”四个等级比较）
// item_code:dimension 维度  item_code:field 领域  grade  year  code   level:district区县
export const gradeRankCompare = (params)=>get('https://yingde_api.ydassess.com/health/district/sub_schools/grade/dim_field/rank/compare',params)


// // （大纲 21 22）多个学校 某年级 六大领域/四大领域 得分柱状图（与“优、良、中、待提高”四个等级比较）
// export const schoolChart = (data)=>post('https://yingde_api.ydassess.com/health/public/unit/grade/dim_field/gender/compare',data)

// 养乐多根据省市区或取集团校id获取某年级六大领域/四大维度得分柱状图接口
export const schoolLegend = (params)=>get('/api/statistics-data-schools-dim/detail',params)


// （大纲 15 16 ）本市各区县 某年级 六大领域/四大领域 得分柱状图（与“优、良、中、待提高”四个等级比较）
// item_code:dimension 维度  item_code:field 领域  grade  year  code   level:city地市
export const districtsRankCompare = (params)=>get('https://yingde_api.ydassess.com/health/city/sub_districts/grade/dim_field/rank/compare',params)

export const cityData =(data) =>post('https://yingde_api.ydassess.com/health/public/unit/grade/dim_field/rank/compare',data)

// 大纲 7）：全年级各班级生命健康素养平均得分率横向比较图 (健康测评、学生数据看板)
// year  code   level  grade
export const gradeClassesScores = (data)=>post('https://yingde_api.ydassess.com/health/school/grade/classes/score/compare',data)


// （大纲 14）查询本市、本区、本校有多少年级    (接口数据问题未调通，学生数据看板)
// year  code  level
export const unitGrades = (params)=>get('https://yingde_api.ydassess.com/health/public/unit/grades',params)


// （大纲 36）本校本年级有多少班级
// grade  year  code  level
export const schoolGradeClasses =  (params)=>get('https://yingde_api.ydassess.com/health/school/grade/classes',params)


// 生命安全与健康 六大领域/四大维度 测评个人得分 （学生、家长）
// （大纲 1 2） 生命安全与健康六大领域/四大维度测评个人得分图
// item_code   student_id
export const dimensionFieldScores = (params)=>get('https://yingde_api.ydassess.com/health/personal/code/scores',params)


// 获取某个地市、区县、学校、班级的某个年级的 rank（优良中差） 百分比分布 （健康测评、学生数据看板）
// (大纲 5 30)：年级学生健康素养水平各等级占比图 （刘）
// grade  year  code  level
export const gradeScoreRank = (data)=>post('https://yingde_api.ydassess.com/health/public/unit/grade/score/gender/rank/compare',data)


// 获取某个地市、区县、学校、班级的某个年级的的 total/M/F scores  （健康测评、学生数据看板）
// （大纲 6 31）：年级学生健康素养水平及性别比较图
// grade  year  code  level
export const gradeScoreGender = (data)=>post('https://yingde_api.ydassess.com/health/public/unit/grade/score/gender/compare',data)


// 获取某个地市、区县、学校、班级的某个年级、维度或领域的 total/M/F scores（健康测评、学生数据看板）
// （大纲 8 9 ）年级六大领域/四大维度测评得分及性别比较图
// （大纲 32 33）班级六大领域/四大维度测评得分及性别比较图
// grade  year  code  level  item_code
export const gradeDimFieldGender = (data)=>post('https://yingde_api.ydassess.com/health/public/unit/grade/dim_field/gender/compare',data)


// 大纲 10）：年级优先关注点
// 获取某个地市、区县、学校的某个年级的的优先关注点（领域）
// grade  year  code  level
export const gradeFocus = (params)=>get('https://yingde_api.ydassess.com/health/public/unit/grade/focus',params)


// (大纲 11)：智能推荐：针对年级优先关注点
// 智能推荐(video and courses)：针对优先关注点（领域）
// focus_list Example: focus_list=健康生活方式&focus_list=疾病预防&focus_list=安全应急与避险 grade
export const focusRecommendResources = (params)=>get('https://yingde_api.ydassess.com/health/public/focus/recommend/resources',params)


// 某年级 六大领域/四大维度 得分柱状图 任意两单位或多单位比较  （学生数据看板）
// （大纲 12 13）：某年级 六大领域/四大维度 得分柱状图（与本区、与本市、与省市、与中全国同年级均分比较）
// （大纲 17 18）：本市各区县各年级六大领域/四大维度 得分柱状图（与数据库中全国同年级均分比较））
// （大纲 19 20）：与全省/全国其它地市各区县各年级六大领域/四大维度柱状图（与数据库中全省/全国其它地市各年级均分比较）
// （大纲 23 24）：全区各学校各年级六大领域/四大维度得分柱状图（与数据库中全国同年级均分比较）
// （大纲 25 26）：本区县各年级与全市各年级六大领域/四大维度得分柱状图（本区县各年级与全区各年级均分比较）
// （大纲 27 28）：与本市其它区县各年级六大领域/四大维度得分柱状图（本区县各年级与本市其它区县各年级均分比较）
// （大纲 34 35）：本班级整体六大领域/四大维度得分柱状图（与本区同年级均分比较，与数据库中全国同年级均分比较）
// codes Example: codes=0&codes=370000&codes=370700&codes=370703&codes=3707030003&codes=370703000302
// year item_code grade

export const gradeDimField = (data)=>post('https://yingde_api.ydassess.com/health/public/units/grade/dim_field/compare',data)

// 多单位对比图

// 智能推荐(video and courses)：针对个人优先关注点（领域）
// （大纲 3） 智能推荐：针对个人优先关注点
// focus_list=健康生活方式&focus_list=疾病预防&focus_list=安全应急与避险  year  student_id
export const focusRecommendResource = (params)=>get('https://yingde_api.ydassess.com/health/personal/focus/recommend/resources',params)


// 获取该学生六个领域低于平均值的领域，即优先关注点。
// （大纲 4） 优先关注点：获取该学生六个领域低于平均值的领域 :return: list[str] 优先关注点列表
// student_id
export const studentFocus = (params)=>get('https://yingde_api.ydassess.com/health/personal/focus',params)


// MHT测评结果仪表盘图
export const TestResultPanel = (params)=>get('https://yingde_api.ydassess.com/health/mht/result/gauge',params)

// MHT测评结果雷达图
export const TestResultRadar = (params)=>get('https://yingde_api.ydassess.com/health/mht/result/radar',params)

// PHQ抑郁测评结果
export const PHQTestResult = (params)=>get('https://yingde_api.ydassess.com/health/mht/result/9lines',params)

// 年级监管数据 - 饼图接口  教师数据看板
export const RegulatorData = (params)=>get('/api/statistics/list/school',params)

// 年级监管 - 饼图接口  家长数据看板
export const parentPie = (data) => post('https://yingde_api.ydassess.com/health/school/cascade/parents/period',data)

// 获取以班级为单位的家长表格数据
export const classToParentTable = (data) => post('https://yingde_api.ydassess.com/health/school/parents',data)

// 获取年级下的班级下拉列表
export const gradeToClassSelect = (data) => post('https://yingde_api.ydassess.com/health/school/grade/classes',data)
 



// WEBPACK FOOTER //
// ./src/api/echarts.js